/* eslint-disable @typescript-eslint/no-empty-function */
import React, { createContext, useState } from 'react';
import { UserProviderProps } from '../types/globalTypes'; 

export interface TableFilter {
  field: string;
  type: string;
  text: string;
}

interface TableFiltersContextType {
  stockFilters: TableFilter[];
  setStockFilters: React.Dispatch<React.SetStateAction<TableFilter[]>>;
  movementFilters: TableFilter[];
  setMovementFilters: React.Dispatch<React.SetStateAction<TableFilter[]>>;
  globalFilter: string;
  setGlobalFilter: React.Dispatch<React.SetStateAction<string>>;
  movementTypeFilter: string;
  setMovementTypeFilter: React.Dispatch<React.SetStateAction<string>>;
  routerStatusFilter: string;
  setRouterStatusFilter: React.Dispatch<React.SetStateAction<string>>;
  freightStatusFilter: string;
  setFreightStatusFilter: React.Dispatch<React.SetStateAction<string>>;
}

const TableFiltersContext = createContext<TableFiltersContextType>({
  stockFilters: [],
  setStockFilters: () => {},
  movementFilters: [],
  setMovementFilters: () => {},
  globalFilter: '',
  setGlobalFilter: () => {},
  movementTypeFilter: '',
  setMovementTypeFilter: () => {},
  routerStatusFilter: '',
  setRouterStatusFilter: () => {},
  freightStatusFilter: '',
  setFreightStatusFilter: () => {}
});

export default TableFiltersContext;

export const TableFiltersProvider: React.FC<any> = ({ children }) => {
  const [stockFilters, setStockFilters] = useState<TableFilter[]>([]);
  const [movementFilters, setMovementFilters] = useState<TableFilter[]>([]);
  const [globalFilter, setGlobalFilter] = useState<string>('');
  const [movementTypeFilter, setMovementTypeFilter] = useState<string>('Pedido');
  const [routerStatusFilter, setRouterStatusFilter] = useState<string>('');
  const [freightStatusFilter, setFreightStatusFilter] = useState<string>('');

  const resetRouterFilters = () => {
    setRouterStatusFilter('');
  };

  const resetFreightFilters = () => {
    setFreightStatusFilter('');
  };

  const resetAllFilters = () => {
    setStockFilters([]);
    setMovementFilters([]);
    setGlobalFilter('');
    setMovementTypeFilter('Pedido'); 
    resetRouterFilters();
    resetFreightFilters();
  };

  return (
    <TableFiltersContext.Provider
      value={{
        stockFilters,
        setStockFilters,
        movementFilters,
        setMovementFilters,
        globalFilter,
        setGlobalFilter,
        movementTypeFilter,
        setMovementTypeFilter,
        routerStatusFilter,
        setRouterStatusFilter,
        freightStatusFilter,
        setFreightStatusFilter,
      }}
    >
      {children}
    </TableFiltersContext.Provider>
  );
};
